<template>
  <div class="approvals-flow-detail-historical px-8 pt-6 pb-6">
    <ApprovalsPanelBackButton
      class="mb-6"
      @click="viewOtherApprovals"
    />

    <div
      v-if="activeFlow"
      class="d-flex flex-column ga-1 mb-6"
    >
      <ApprovalStatusPill
        :status="activeFlow.status"
        mode="overall"
      />

      <div class="text-h1 text-textDarkest">
        {{ activeFlow.draft_profile?.title || '' }}
      </div>

      <p
        v-if="activeFlow.draft_profile?.job_code"
        class="text-body-1 text-textLight mb-0"
      >
        Job Code: {{ activeFlow.draft_profile.job_code }}
      </p>
    </div>

    <ApprovalFlowMetadata
      v-if="activeFlow"
      :flow="activeFlow"
      :template-name="templateName"
      class="mb-6"
    />

    <ApprovalFlowStagesView :flow="activeFlow" />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import ApprovalFlowMetadata from '@/components/jobProfiles/editor/approvals/ApprovalFlowMetadata.vue';
import ApprovalFlowStagesView from '@/components/jobProfiles/editor/approvals/ApprovalFlowStagesView.vue';
import ApprovalsPanelBackButton from '@/components/jobProfiles/editor/approvals/ApprovalsPanelBackButton.vue';
import ApprovalStatusPill from '@/components/jobProfiles/editor/ApprovalStatusPill.vue';
import { useApprovalFlows } from '@/stores/jobProfiles/approvalFlows';
import { getTemplateNameByUlid } from '@/helpers/approvalFlows';

const approvalFlowsStore = useApprovalFlows();
const { activeFlow, templates } = storeToRefs(approvalFlowsStore);
const { viewOtherApprovals } = approvalFlowsStore;

const templateName = computed(() => (
  getTemplateNameByUlid(templates.value, activeFlow.value?.template_ulid)
));
</script>
